import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import {required} from 'vee-validate/dist/rules';
import moment from 'moment';
import _, { isNumber } from 'lodash';
import store from '../store';

Object.keys(rules).forEach(rule => {
	extend(rule, rules[rule]);
});

extend('confirm', {
	params: ['target'],
	validate(value, { target }) {
		return value === target;
	},
	message: 'A Jelszavak nem egyeznek',
});

extend('password', {
	validate(value) {
		var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*,._><&?~^=()-/\\\\])(?=.{8,})');
		return strongRegex.test(value);
	},
	message: `A jelszó minimum 8 karakter és tartalmaznia kell minimum 1 nagy betű, 1 kisbetű, 1 szám és 1 speciális karakter (pl. , . _ & ? stb)`,
});

extend('birth_date', {
	params: ['min_age'],
	validate(value, { min_age }) {
		const dateValue = moment().diff(value);
		const result = moment.duration(dateValue).asYears();

		return result > min_age;
	},
	computesRequired: true,
	message: 'A {_field_} értéke nem megfelelő. Minimum {min_age} évesnek kell lenned.',
});

extend('max_now_date', {
	validate(value) {
		return moment(value).isSameOrBefore(moment());
	},
	message: 'A {_field_} értéke nem megfelelő. Maximum a mai nap adható meg!',
});

extend('date_between', {
	params: ['min', 'max'],
	validate(value, { min, max }) {
		const dateValue = moment(value);
		const minValue = moment();
		const maxValue = moment();

		if (min !== 'now') {
			const minArray = min.includes('+') ? min.split('+') : min.split('-');

			if (min.includes('+')) {
				minValue.add(minArray[1], 'd');
			} else {
				minValue.subtract(minArray[1], 'd');
			}
		}

		if (max !== 'now') {
			const maxArray = max.includes('+') ? max.split('+') : max.split('-');

			if (max.includes('+')) {
				maxValue.add(maxArray[1], 'd');
			} else {
				maxValue.subtract(minArray[1], 'd');
			}
		}

		return dateValue.isBetween(minValue, maxValue);
	},
	message: 'A {_field_} értéke nem megfelelő.',
});

extend('search', {
	params: ['results', 'prop'],
	validate(value, { results, prop }) {
		const result = _.find(results, item => {
			if ((_.has(item, 'nature') && item.nature !== null) && prop === 'address') {
				return `${item.name} ${item.nature}` === value;
			}

			return item.name === value;
		});

		return result !== null && result !== undefined;
	},
	message: 'A {_field_} értéke nem megfelelő.',
});

extend('number_space', {
	validate(value) {
		return /^[0-9\s]*$/g.test(value);
	},
	message: 'A {_field_} értéke nem megfelelő.',
});

extend('letter_space_hypens', {
	validate(value) {
		return /^[a-zA-Z.\u00C0-\u024F]+(?:[\s\-'.&/][a-zA-Z.\u00C0-\u024F\d]+)*(?:[.|\s])?(?:[\(a-z\)])*$/.test(value);
	},
	message: 'A {_field_} értéke nem megfelelő.',
});

extend('full_name', {
	validate(value) {
		return /^([a-zA-Z\u00C0-\u024F]+) ([a-zA-Z\u00C0-\u024F]+)( [a-zA-Z\u00C0-\u024F]+)*$/gm.test(value);
	},
	message: 'A {_field_} értéke nem megfelelő.',
});

extend('mfo_is_true', {
	validate(value) {
		return value;
	},
	message: 'Minősített Fogyasztóbarát Otthonbiztosítás termék csak állandóan lakott ingatlanra köthető!',
});

extend('mfo_min', {
	params: ['min'],
	validate(value, { min }) {
		return value >= min;
	},
	message: 'Minősített Fogyasztóbarát Otthonbiztosítás termék csak állandóan lakott ingatlanra köthető!',
});

extend('outbuilding_is_separate', {
	validate(value) {
		return value > 0;
	},
	message: 'Csak azonos címen fekvő épületekre lehet MFO-t kötni!',
});

extend('divisible_by_thousand', {
	validate(value) {
		const number = !isNumber(value) ? parseInt(value.replace(/\s/g, '')) : value;

		return number % 1000 === 0;
	},
	message: 'Az összegnek oszthatónak kell lennie ezerrel.',
});

extend('bank_account_number', {
	validate(value) {
		return /^[0-9]{8}-[0-9]{8}(-[0-9]{8})?$/g.test(value);
	},
	message: 'Nem megfelelő bankszámlaszám formátum.',
});

extend('bank_search', {
	params: ['banks'],
	validate(value, { banks }) {
		if (banks !== null) {
			const code = parseInt(value.toString().slice(0, 3));
			const bankName = store.getters['contracting/getFormData']({
				parent: 'baseData',
				group: 'paymentDetails',
				prop: 'bank_name',
			});
			const selectedBank = banks.find(bank => bank.code === code);
			const isAvaibleBank = banks.find(bank => bank.name.toLowerCase().includes(bankName.toLowerCase()));

			if (bankName === null) {
				if (selectedBank !== undefined) {
					store.commit('contracting/setFormData', {
						parent: 'baseData',
						group: 'paymentDetails',
						prop: 'bank_name',
						value: selectedBank.name,
					});
				}
				return true;
			} else {
				if (isAvaibleBank !== undefined) {
					return selectedBank.name.toLowerCase().includes(bankName.toLowerCase());
				} else {
					return selectedBank === undefined;
				}
			}
		}
	},
	message: 'A megadott bankhoz nem megfelelő bankszámlaszám.',
});

extend('required_target', {
	params: ['target'],
	validate(value, { target }) {
		return {
			required: target === null,
			valid: target === null ? ['', null, undefined].indexOf(value) === -1 : true,
		};
	},
	message: 'A(z) {_field_} megadása kötelező!',
	computesRequired: true,
});

extend('day_before_60', {
	validate(value) {
		const dateValue = moment(value).subtract(60, 'days');
		const result = moment().isSameOrBefore(dateValue);

		return !result;
	},
	message:
		'A távoli dátumérték miatt nem kalkulálhatók díjak, a biztosítók csak később teszik nyilvánossá az aktuális tarifáikat, kérjük, térjen vissza oldalunkra a felmondási határidő előtt 60 nappal!',
});

extend('phone', {
	validate(value) {
		if (value.length < 9) {
			return false;
		}

		return /^(\+36|06) ?(\d{1,2}) ?(\d{3}) ?(\d{3,4})$/g.test(value);
	},
	message: 'Nem megfelelő telefonszám formátum!',
});

extend('rate_is_100', {
	validate() {
		const rateFields = document.querySelectorAll('input[name=rate]');
		let result = 0;

		rateFields.forEach(field => {
			result += parseInt(field.value);
		});

		return result === 100;
	},
	message: 'A {_field_} összegének 100%-nak kell lennie.',
});

extend('wired_phone', {
	validate(value) {
		if (value.length < 9) {
			return false;
		}
		return /^(\+36|06) ?((?!20|21|30|31|40|50|51|55|60|70|80|90|91)\d{1,2}) ?(\d{3}) ?(\d{3,4})$/g.test(value);
	},
	message: 'Nem megfelelő telefonszám formátum!',
});

extend('wired_cant_be_mobile', {
	params: ['target'],
	validate(value, { target }) {
		return value !== target;
	},
	message: 'Kérjük, szíveskedjen vonalas telefonszámot megadni, mobilszám nem használható!',
});

extend('percent_2digit', {
    validate(value) {
        return /(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$)/g.test(value);
    },
    message: 'Kérjük, szíveskedjen egész számot megadni pl. 25 vagy tört számot két tizedes törtig pl. 25.25 !',
});

extend('marketing_checkbox', {
    ...required,
    validate(value) {
        return value === true;
    },
    message: 'A mező bepipálása kötelező.',
});
